import cx from "classnames";
import PropTypes from "prop-types";
import { Component } from "react";

import CS from "metabase/css/core/index.css";
import { PLUGIN_LOGO_ICON_COMPONENTS } from "metabase/plugins";

// Just define the URL as a constant (string), not imported as a module
const MY_LOGO_URL = "https://res.cloudinary.com/dmanivegq/image/upload/v1713397452/bg_cntrx1.png";

class DefaultLogoIcon extends Component {
  static defaultProps = {
    height: 32,
  };

  static propTypes = {
    width: PropTypes.number,
    height: PropTypes.number,
    dark: PropTypes.bool,
    fill: PropTypes.string,
  };

  render() {
    const { dark, height, width } = this.props;

    const className = cx(
      "Icon",
      { [CS.textBrand]: !dark },
      { [CS.textWhite]: dark },
    );

    // We'll inline style the width/height (you can also rely on CSS if you prefer)
    const style = {
      width: width || "auto",
      height: height,
    };

    return (
      <img
        src={MY_LOGO_URL}
        alt="OBxAnalytics"
        className={className}
        style={style}
        data-testid="main-logo"
      />
    );
  }
}

export default function LogoIcon(props) {
  const [Component = DefaultLogoIcon] = PLUGIN_LOGO_ICON_COMPONENTS;
  return <Component {...props} />;
}
